module.exports = ".submit-btn{\n    width: 150px;\n    height: 40px;\n    background-color: #242829;\n    color: #FFFFFF;\n    font-family: Montserrat, sans-serif;\n    font-size: 14px;\n    font-weight: 400;\n    border: none;\n    cursor: pointer;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/delete-agent-employee-dialog/delete-agent-employee-dialog.component.css
// module id = ./src/app/components/delete-agent-employee-dialog/delete-agent-employee-dialog.component.css
// module chunks = main